import { Card, Dialog, DialogContent, DialogTitle, Divider, Grid, makeStyles } from "@material-ui/core";

import React, { useState } from "react";
import { Button, FormDataConsumer, SelectInput, TextInput, useDataProvider, useNotify } from "react-admin";
import { Form } from "react-final-form";
import { CustomDatetime } from "../../../Components/CustomDatetime";
import { SectionTitle } from "../../../Components/SectionTitle";
import { Separator } from "../../../Components/Separator";
import ReliabilityReportRemarkTimeline from "../ReliabilityReportRemarks";
import { Add, Update } from "@material-ui/icons";
import { ReliabilityReportRemarkCreateModel } from "../Models/ReliabilityReportRemarkCreateModel";
import { useAppDataProvider } from "../../../../src/dataprovider";
import { ReliabilityReportUpdateModel } from "../Models/ReliabilityReportModels";
import { ReliabilityReportStatusChoices } from "../../../../src/Enums/ReliabilityReportStatus";
import { ReliabilityFoFChoices, ReliabilityFofStatus } from "../../../../src/Enums/ReliabilityFoFStatus";
import { useAuth } from "@airborne/react-admin";
import {
  ReliabilityFofReasonType,
  ReliabilityFoFRejectReasonType,
  ReliabilityNotFoFReasonType,
} from "../../../../src/Enums/ReliabilityFofReasonType";
import { ReliabilityThyFailOnFitUpdateModel } from "../Models/ReliabilityThyFailOnFitModel";
import ReliabilityOtherConditions from "../ReliabilityOtherConditions";

const useStyles = makeStyles(theme => ({
  toolbar: {
    display: "flex",
    justifyContent: "end",
  },
  gridItem: {
    margin: "0px 10px",
  },
}));

export const ThyFailOnFitDetail = props => {
  const provider = useDataProvider();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({} as any);
  const notify = useNotify();
  const [isReliabilityReportButtonShow, setIsReliabilityReportButtonShow] = useState(false);
  const [isFailOnFitButtonShow, setIsFailOnFitButtonShow] = useState(false);
  const [isDisabledReportFields, setIsDisabledReportFields] = useState(true);
  const [isDisabledFailOnFitFields, setIsDisabledFaiOnFitFields] = useState(true);
  const [isReasonRequired, setIsReasonRequired] = useState(false);
  const [isFof, setisFof] = useState(null as any);
  const dataProvider = useAppDataProvider();
  const { user } = useAuth();

  React.useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    provider
      .getOne("reliabilitythyfailonfits", {
        id: props.id,
      })
      .then(response => {
        setData(response.data);

        if (
          response.data.fofStatus === ReliabilityFofStatus.Rejected ||
          response.data.fofStatus === ReliabilityFofStatus.NotFof
        ) {
          response.data.fofStatus === ReliabilityFofStatus.Rejected ? setisFof(false) : setisFof(true);
          setIsReasonRequired(true);
        } else {
          setIsReasonRequired(false);
        }
      })
      .catch(error => {});
  };
  const editReliabilityReport = e => {
    setIsReliabilityReportButtonShow(true);
    setIsDisabledReportFields(false);
  };

  const editReliabilityReportButtonClick = formValues => e => {
    let reliabilityReport: ReliabilityReportUpdateModel = new ReliabilityReportUpdateModel();
    reliabilityReport.Id = data?.report?.id;
    reliabilityReport.GoodsRcvdBatch = data?.report?.goodsRcvdBatch;
    reliabilityReport.Pn = data?.report?.pn;
    reliabilityReport.Sn = data?.report?.sn;
    reliabilityReport.Chapter = data?.report?.chapter;
    reliabilityReport.ReportType = data?.report.reportType;
    reliabilityReport.ReportStatus = formValues.reportStatus;
    reliabilityReport.TargetDate = formValues.targetDate;

    dataProvider
      .putReliabilityReport(reliabilityReport)
      .then(result => {
        notify(`Reliability Report Updated`, "success", false, true);
        setIsReliabilityReportButtonShow(false);
        setIsDisabledReportFields(true);
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const CancelEditingReliabilityReport = e => {
    setIsReliabilityReportButtonShow(false);
    setIsDisabledReportFields(true);
  };

  const editFailOnFit = e => {
    setIsFailOnFitButtonShow(true);
    setIsDisabledFaiOnFitFields(false);
  };

  const editThyFailOnFitButtonClick = e => {
    let reliabilityThyFailOnFit: ReliabilityThyFailOnFitUpdateModel = new ReliabilityThyFailOnFitUpdateModel();
    reliabilityThyFailOnFit.Id = data?.id;
    reliabilityThyFailOnFit.ReportId = data?.reportId;
    reliabilityThyFailOnFit.Batch = data?.batch;
    reliabilityThyFailOnFit.BeforeRemovalOrderType = data?.beforeRemovalOrderType;
    reliabilityThyFailOnFit.BeforeRemovalOrderNumber = data?.beforeRemovalOrderNumber;
    reliabilityThyFailOnFit.BeforeRemovalOrderStatus = data?.beforeRemovalOrderStatus;
    reliabilityThyFailOnFit.BeforeRemovalVendorType = data?.beforeRemovalVendorType;
    reliabilityThyFailOnFit.BeforeRemovalVendor = data?.beforeRemovalVendor;
    reliabilityThyFailOnFit.BeforeRemovalCondition = data?.beforeRemovalCondition;
    reliabilityThyFailOnFit.AfterRemovalOrderType = data?.afterRemovalOrderType;
    reliabilityThyFailOnFit.AfterRemovalOrderNumber = data?.afterRemovalOrderNumber;
    reliabilityThyFailOnFit.AfterRemovalOrderStatus = data?.afterRemovalOrderStatus;
    reliabilityThyFailOnFit.AfterRemovalVendorType = data?.afterRemovalVendorType;
    reliabilityThyFailOnFit.AfterRemovalVendor = data?.afterRemovalVendor;
    reliabilityThyFailOnFit.AfterRemovalCondition = data?.afterRemovalCondition;
    reliabilityThyFailOnFit.AcReg = data?.acReg;
    reliabilityThyFailOnFit.AcType = data?.acType;
    reliabilityThyFailOnFit.FleetType = data?.fleetType;
    reliabilityThyFailOnFit.AcRemoveDate = data?.acRemoveDate;
    reliabilityThyFailOnFit.FofStatus = e.fofStatus;
    reliabilityThyFailOnFit.Reason = e.reason;
    reliabilityThyFailOnFit.OtherReason = e.otherReason;

    dataProvider
      .putReliabilityThyFailOnFit(reliabilityThyFailOnFit)
      .then(result => {
        notify(`Reliability THY Fail On Fit Updated`, "success", false, true);
        setIsFailOnFitButtonShow(false);
        setIsDisabledFaiOnFitFields(true);
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const CancelEditingFailOnFit = e => {
    setIsFailOnFitButtonShow(false);
    setIsDisabledFaiOnFitFields(true);
  };

  const AddReliabilityReportRemarkButton = props => {
    const [open, setOpen] = useState(false);

    const handleClick = e => {
      e.stopPropagation();
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };

    const AddReliabilityReportRemarkButtonClick = props => e => {
      let reliabilityRemark: ReliabilityReportRemarkCreateModel = new ReliabilityReportRemarkCreateModel();

      reliabilityRemark.ReliabilityReportId = props.reliabilityReportId;
      reliabilityRemark.IsVisibleToCustomer = true;
      reliabilityRemark.Remark = e.remark;

      dataProvider
        .postReliabilityReportRemark(reliabilityRemark)
        .then(result => {
          notify(`Reliability THY Report Remark Added`, "success", false, true);
          history.go(0);
          setOpen(false);
        })
        .catch(result => notify(`${result}`, "error", false, true))
        .finally(() => setLoading(false));
    };

    const ClosePopup = () => {
      setOpen(false);
    };

    return (
      <>
        <Button label="Add Remark" disabled={loading} size="medium" variant="contained" onClick={handleClick}>
          {<Add />}
        </Button>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Reliability Report Remark</DialogTitle>
          <DialogContent>
            <Form
              onSubmit={AddReliabilityReportRemarkButtonClick(props)}
              render={({ handleSubmit }) => (
                <form>
                  <TextInput source="remark" label="remark" size="medium" fullWidth variant="outlined" />
                  <Button label={"Add Remark!"} size="large" variant="contained" onClick={handleSubmit}>
                    <Update />
                  </Button>
                  <Button label={"Cancel!"} size="large" variant="contained" onClick={ClosePopup} color="secondary">
                    <Update />
                  </Button>
                </form>
              )}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  };

  const CheckValidate = e => {
    if (e.target.value === ReliabilityFofStatus.Rejected || e.target.value === ReliabilityFofStatus.NotFof) {
      e.target.value === ReliabilityFofStatus.Rejected ? setisFof(false) : setisFof(true);
      setIsReasonRequired(true);
    } else {
      setIsReasonRequired(false);
    }
  };

  return (
    <>
      <Form
        onSubmit={() => {}}
        render={({ handleSubmit, form, values }) => {
          return (
            <form>
              <Card>
                <Grid container spacing={0} style={{ padding: 25 }}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <SectionTitle label="Reliability Report Details" />
                    <Divider style={{ padding: 0 }} />
                    <Separator />
                  </Grid>

                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <TextInput
                      source="goodsRcvdBatch"
                      label="Goods Received Batch"
                      initialValue={data?.report?.goodsRcvdBatch}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="chapter"
                      label="Chapter"
                      initialValue={data?.report?.chapter}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <SelectInput
                      source="reportStatus"
                      label="Report Status"
                      initialValue={data?.report?.reportStatus}
                      choices={ReliabilityReportStatusChoices}
                      optionText="key"
                      optionValue="value"
                      fullWidth
                      disabled={isDisabledReportFields}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <TextInput
                      source="pn"
                      label="PN"
                      initialValue={data?.report?.pn}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="pnDescription"
                      initialValue={data?.pnDescription}
                      label="PN Description"
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <CustomDatetime
                      source="targetDate"
                      label="Target Date"
                      initialValue={data?.report?.targetDate}
                      fullWidth
                      showTime
                      disabled={isDisabledReportFields}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <TextInput
                      source="sn"
                      label="SN"
                      initialValue={data?.report?.sn}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="pnSubCategory"
                      label="SUB Category"
                      initialValue={data?.pnSubCategory}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={0} style={{ padding: 25, justifyContent: "start", margin: 10 }}>
                  <SectionTitle label="Reliability Other Condition" />
                  {data?.report?.goodsRcvdBatch != undefined && (
                    <ReliabilityOtherConditions goodsRcvdBatch={data?.report?.goodsRcvdBatch} />
                  )}
                </Grid>

                <Grid container spacing={0} style={{ padding: 25, justifyContent: "end" }}>
                  {!user?.isCustomer && !isReliabilityReportButtonShow && (
                    <Button
                      label="Edit Reliability Report"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={editReliabilityReport}
                      style={{ margin: "8px", background: "#ffc107" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                  {isReliabilityReportButtonShow && (
                    <Button
                      label="Edit"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={editReliabilityReportButtonClick(values)}
                      style={{ margin: "8px", background: "#4caf50" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                  {isReliabilityReportButtonShow && (
                    <Button
                      label="Cancel"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={CancelEditingReliabilityReport}
                      style={{ margin: "8px", background: "#ffc107" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                </Grid>
                <ReliabilityReportRemarkTimeline
                  reliabilityReportRemark={data?.reliabilityReportRemark}
                  refresh={getData}
                  isCustomerRelated={false}
                />
                <Grid container spacing={0} style={{ padding: 25, justifyContent: "end" }}>
                  <AddReliabilityReportRemarkButton reliabilityReportId={data?.report?.id} />
                </Grid>
              </Card>
            </form>
          );
        }}
      ></Form>

      <Separator />

      <Form
        initialValues={data}
        onSubmit={editThyFailOnFitButtonClick}
        render={({ handleSubmit, form, values }) => {
          return (
            <form>
              <Card>
                <Grid container spacing={0} style={{ padding: 25 }}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <SectionTitle label="Fail On Fit Details" />
                    <Divider style={{ padding: 0 }} />
                    <Separator />
                  </Grid>
                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <TextInput
                      source="batch"
                      label="Batch"
                      initialValue={data?.batch}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="beforeRemovalOrderType"
                      label="Before Removal Order Type"
                      initialValue={data?.beforeRemovalOrderType}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="beforeRemovalOrderNumber"
                      label="Before Removal Order Number"
                      initialValue={data?.beforeRemovalOrderNumber}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="beforeRemovalVendorType"
                      label="Before Removal Vendor Type"
                      initialValue={data?.beforeRemovalVendorType}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="beforeRemovalVendor"
                      label="Before Removal Vendor"
                      initialValue={data?.beforeRemovalVendor}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="beforeRemovalCondition"
                      label="Before Removal Condition"
                      initialValue={data?.beforeRemovalCondition}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <TextInput
                      source="acReg"
                      label="AC Reg"
                      initialValue={data?.ac}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <CustomDatetime
                      source="acRemoveDate"
                      label="AC Remove Date"
                      initialValue={data?.acRemoveDate}
                      fullWidth
                      showTime
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="afterRemovalOrderType"
                      label="After Removal Order Type"
                      initialValue={data?.afterRemovalOrderType}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="afterRemovalOrderNumber"
                      label="After Removal Order Number"
                      initialValue={data?.afterRemovalOrderNumber}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="afterRemovalVendorType"
                      label="After Removal  Vendor Type"
                      initialValue={data?.afterRemovalVendorType}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="afterRemovalVendor"
                      label="After Removal Vendor"
                      initialValue={data?.afterRemovalVendor}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="afterRemovalCondition"
                      label="After Removal Condition"
                      initialValue={data?.afterRemovalCondition}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <SelectInput
                      source="fofStatus"
                      label="Fail On Fit Status"
                      initialValue={data?.fofStatus}
                      choices={ReliabilityFoFChoices}
                      optionText="key"
                      optionValue="value"
                      fullWidth
                      onChange={CheckValidate}
                      disabled={isDisabledFailOnFitFields}
                      variant="outlined"
                    />

                    {isReasonRequired && (
                      <SelectInput
                        source="reason"
                        label="Reject Reason"
                        initialValue={data?.reason}
                        choices={isFof ? ReliabilityNotFoFReasonType : ReliabilityFoFRejectReasonType}
                        optionText="key"
                        optionValue="value"
                        fullWidth
                        disabled={isDisabledFailOnFitFields}
                        variant="outlined"
                      />
                    )}

                    <FormDataConsumer>
                      {({ formData, ...rest }) =>
                        formData.reason === ReliabilityFofReasonType.Other &&
                        isReasonRequired && (
                          <TextInput
                            source="otherReason"
                            label="Other Reason"
                            initialValue={data?.otherReason}
                            fullWidth
                            variant="outlined"
                            disabled={isDisabledFailOnFitFields}
                            multiline
                            {...rest}
                          />
                        )
                      }
                    </FormDataConsumer>
                  </Grid>
                </Grid>
                <Grid container spacing={0} style={{ padding: 25, justifyContent: "end" }}>
                  {!user?.isCustomer && !isFailOnFitButtonShow && (
                    <Button
                      label="Edit Fail On Fit"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={editFailOnFit}
                      style={{ margin: "8px", background: "#ffc107" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                  {isFailOnFitButtonShow && (
                    <Button
                      label="Edit"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={handleSubmit}
                      style={{ margin: "8px", background: "#4caf50" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                  {isFailOnFitButtonShow && (
                    <Button
                      label="Cancel"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={CancelEditingFailOnFit}
                      style={{ margin: "8px", background: "#ffc107" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                </Grid>
              </Card>
            </form>
          );
        }}
      ></Form>
    </>
  );
};
export default ThyFailOnFitDetail;
